import { useContext } from 'react';
import { SidebarContext, SidebarContextType } from '../contexts/sidebar_context';

const useSidebar = () => {
    return useContext(SidebarContext) as SidebarContextType;
};

export default useSidebar;
